import typOpony from '@components/search/inputs/typOpony'
import profil from '@components/search/inputs/profil'
import szerokosc from '@components/search/inputs/szerokoscCzesci'
import srednica from '@components/search/inputs/srednica'

const opony = {
    type: 'conditional',
    name: 'opony',
    conditions: { 'rodzaj-czesci': 'Opony' },
    inputs: [
        typOpony,
        profil,
        szerokosc,
        srednica,
    ],
}

export default opony